import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Provider} from "react-redux";
import {store} from './Reducers/index';
import { GoogleMapsProvider } from './Components/GoogleMaps/googleMapContext';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <GoogleMapsProvider>
                <App/>
            </GoogleMapsProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
